export class PagingState {
    public page = 1;
    public pageSize = 20;
    public search = '';
}
